export enum StandardWorkflowJobTabs {
  History,
  Audit,
  RelatedDocuments,
  DocumentInformation,
  Narrative,
  Versions,
  FullText,
  Tracing
}
